import Swal from "sweetalert2";
import styled from 'styled-components';
import { NavLink } from "react-router-dom";
import { Spinner } from 'react-bootstrap';
import DeleteIcon from 'mdi-react/DeleteIcon';
import React, { useState, useEffect } from 'react';
import { Button } from '@/shared/components/Button';
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import { paddingLeft, paddingRight } from '@/utils/directions';
import ReactTableBase from '@/shared/components/table/ReactTableBase';
import { colorAdditional, colorGreenHover, colorAccent } from '@/utils/palette';
import { Card, CardBody, CardTitleWrap, CardTitle } from '@/shared/components/Card';

const CartTableButton = styled.button`
  background: transparent;
  border: none;
  line-height: 14px;
  ${paddingLeft}: 20px;
  ${paddingRight}: 0;
  padding-top: 0;
  padding-bottom: 0;
  position: relative;
  color: ${colorAdditional};
  cursor: pointer;
  transition: all 0.3s;

  svg {
    height: 20px;
    width: 20px;
    fill: ${colorAdditional};
    transition: all 0.3s;
  }

  &:hover {
    color: ${colorGreenHover};

    svg {
      fill: ${colorGreenHover};
    }
  }
`;

const TableSpinner = styled(Spinner)`
  color: ${colorAccent};
`;

const MissionInstrumentsForm = (props) => {
  const [instruments, setInstruments] = useState();
  const [showLoader, setShowLoader] = useState(true);
  const [missionInstrumentsList, setMissionInstrumentsList] = useState({ tableHeaderData: [], tableRowsData: [] });
  const tableConfig = {
    isEditable: false,
    isSortable: true,
    isResizable: false,
    withPagination: false,
    withSearchEngine: false
  };

  const handleDelete = (missionInstrument) => {
    AdminInterface.instance.deleteMissionInstrument(missionInstrument).then(() => {
      withReactContent(Swal).fire({
        title: "Success",
        html: "Mission instrument is deleted!",
      });
      props.setReloadMission(true);
    }).catch((error) => {
      withReactContent(Swal).fire({
        title: "Error",
        html: [error.response?.data?.detail.map((detail) => detail.msg)],
      });
    });
  }

  const setTableData = (instrumentsData) => {
    setShowLoader(true);
    const columns = [
      {
        accessor: 'insrtument',
        Header: 'Instrument',
      },
      {
        accessor: 'calibration_id',
        Header: 'Calibration file',
      },
      {
        accessor: 'delete',
        Header: 'Delete',
        disableGlobalFilter: true,
        disableSortBy: true,
      }
    ];

    const data = [];
    instrumentsData.forEach((missionInstrument, index) => {
      data.push({
        insrtument: instruments.find(instrument => instrument.id === missionInstrument.instrumentId)?.name,
        calibration_id: missionInstrument.calibration?.description,
        delete: <CartTableButton index={index} type="button" onClick={() => handleDelete(missionInstrument)}><DeleteIcon /></CartTableButton>,
      });
    });

    setMissionInstrumentsList({ tableHeaderData: columns, tableRowsData: data });
    setShowLoader(false);
  }

  const getInstruments = () => {
    AdminInterface.instance.getInstruments().then((response) => {
      setInstruments(response.data)
    }).catch((error) => {
      withReactContent(Swal).fire({
        title: "Error",
        html: error.response?.data?.detail,
      });
    });
  }

  useEffect(() => {
    if (props.instrumentsData == undefined) return;
    getInstruments();
  }, [props.instrumentsData]);

  useEffect(() => {
    if (instruments == undefined) return;
    setTableData(props.instrumentsData);
  }, [instruments]);

  return (
    <>
      <CardTitleWrap>
        <CardTitle>Instruments List</CardTitle>
      </CardTitleWrap>
      <NavLink to={{ pathname: "/assets/missions/instruments", state: props.missionId }}><Button size="sm" variant="primary" >Add Instrument</Button></NavLink>
      {
        !showLoader &&
        <ReactTableBase columns={missionInstrumentsList.tableHeaderData} data={missionInstrumentsList.tableRowsData} tableConfig={tableConfig} />
      }
      {showLoader && (<div className="text-center"><TableSpinner animation="border" /></div>)}
    </>
  );
};

export default MissionInstrumentsForm;